@if (notificationMessage$ | async; as notificationMessage) {
  <ss-modal
    [@modalAnimation]
    [open]="true"
    modalheight="fit-content"
    [modalwidth]="notificationMessage.modalWidth ?? 'fit-content'"
    (closeClick)="closeModal()"
    [showClosingX]="false"
    [enableCloseOutside]="false"
  >
    <div class="flex flex-col justify-between h-full">
      <div class="p-6 text-center">
        <h3 class="text-xl md:text-2xl text-ss-brown">
          {{ notificationMessage?.title }}
        </h3>
        <p class="whitespace-pre-wrap">{{ notificationMessage?.message }}</p>
      </div>
      <div class="flex flex-row justify-center mx-6 mb-6">
        <ss-button
          buttonColor="accent"
          buttonStyle="filled"
          (click)="closeModal()"
          class="w-fit"
          >{{ notificationMessage?.closeButtonMessage ?? 'Okay' }}</ss-button
        >
      </div>
    </div>
  </ss-modal>
}
